<template>
  <div id="calculator-section">
    <div class="calc-form-section">
      <!-- CALCULATE FORM -->
      <div class="container">
        <h2 class="calc-title mb-3">{{ $t('calculatorTitle') }}</h2>
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <form class="" v-on:submit.prevent="passes(calculate)">
            <div class="row">
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label class="d-block">{{ $t('calcLabelCurrency') }}</label>
                  <div>
                    <select @change="changeAmountOpt($event)" v-model="calcForm.currency" class="custom-select">
                      <option v-for="option in currencyOptions" :key="option.value" :value="option.value">
                        {{ option.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label class="d-block">{{ $t('calcLabelInvestment') }}</label>
                  <div>
                    <select v-if="!isManual" v-model="calcForm.amount" class="custom-select">
                      <option v-for="option in amountOptions" v-bind:key="option.value" :value="option.value">
                        {{ option.text }}
                      </option>
                    </select>

                    <!-- <div v-if="isManual" class="input-group">
                      <input v-model="calcForm.amount" type="text" class="form-control">
                    </div> -->

                    <ValidationProvider v-if="isManual && calcForm.currency == 'IDR'" name="amount" rules="min_value:250000000" v-slot="{ errors }">
                      <input v-model="calcForm.amount" class="form-control" type="text">
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider v-if="isManual && calcForm.currency == 'USD'" name="amount" rules="min_value:20000" v-slot="{ errors }">
                      <input v-model="calcForm.amount" class="form-control" type="text">
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>


                    <div>
                      <label>
                        <input
                          type="checkbox"
                          v-model="isManual"
                        >
                        {{ $t('calcOther') }}
                      </label>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label class="d-block">{{ $t('calcLabelPeriod') }}</label>
                  <div>
                    <select v-model="calcForm.timePeriod" class="custom-select">
                      <option v-for="option in timePeriodOptions" v-bind:key="option.value" :value="option.value">
                        {{ option.text }} {{ $t('calYear')}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div role="group" class="form-group">
                  <label class="d-block">{{ $t('calcLabelStartDate') }}</label>
                  <div>
                    <div class="input-group">
                      <input id="datepicker" type="text" readonly="readonly" autocomplete="off" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-yellow-custom">{{ $t('calButtonCalPage') }}</button>
          </form>
        </ValidationObserver>


      </div>
    </div>
    <br />

    <!-- CALCULATE RESULT -->
    <CalculateResult
      v-show="showResult"
      :calcForm="calcForm"
      :calcResult="calcResult"
    >
    </CalculateResult>

    <!-- REGISTER MODAL -->
    <div class="modal fade" id="registerModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">CLOSE</span>
          </button>
          <div class="modal-body">
            <RegisterForm :includeTncModal="false" />
          </div>
        </div>
      </div>
    </div>

    <TncModal />
  </div>
</template>

<script>
import CalculateResult from '@/components/CalculateResult.vue'
import RegisterForm from '@/components/RegisterForm.vue'
import TncModal from '@/components/TncModal.vue'
import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapState } from 'vuex'

export default {
  name: 'CalculatePage',
  components: {
    CalculateResult,
    RegisterForm,
    TncModal,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      calcResult: {},
      showResult: false,
      error: {
        status: false,
        message: ''
      },
      isManual: false
    }
  },
  computed: {
    ...mapState([
      'currencyOptions',
      'timePeriodOptions',
      'amountOptions',
      'calcForm'
    ])
  },
  watch: {
    calcForm: {
      deep: true,
      handler(newVal, oldVal){
        this.$store.dispatch('setRegisterValFromCalc', newVal)
      }
    }
  },
  mounted: function() {
    var self = this;
    $("#datepicker").datepicker({
      dateFormat: 'dd M yy',
      onSelect:function(selectedDate, datePicker) {
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.calcForm.investmentDate = formatSelectedDate;
      }
    });
  },
  methods: {
    calculate() {
      let self = this
      let investmentDate = self.$options.filters.formatDate(this.calcForm.investmentDate);

      this.$axios.post('/api/v1/priority/calculateReturn', {
        "currency": self.calcForm.currency,
        "timePeriod": self.calcForm.timePeriod,
        "investmentDate": investmentDate,
        "amount": Number(self.calcForm.amount)
      })
      .then(function (response) {
        let result = response.data.data
        self.calcResult = result
        self.showResult = true
      })
      .catch(function (error) {
        self.error = {
          status: true,
          message: error.message
        }
      });
    },
    changeAmountOpt(e) {
      let currency = e.target.value
      if(currency == "IDR") {
        this.isManual = false
      }
      this.$store.dispatch('changeCurrency', currency)
    }
  }
};
</script>

